import React, { useMemo } from 'react'

import { useFormatMessage } from 'lib/localization'
import { useCallbackPrompt } from 'lib/hooks/useCallbackPrompt'

import WarningDialog from 'components/libs/dialog/warningDialog/WarningDialog'

const BASE_I18N_KEY_DIALOG = 'ess.dialog'

const BlockNavigationDialog: React.FC<{ hasChanges: boolean }> = ({ hasChanges }) => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY_DIALOG)
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(hasChanges)

  return useMemo(
    () => (
      <WarningDialog
        open={showPrompt}
        title={formatMessage('block_navigation_bulk_edit.title')}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
        cancelButtonLabel={formatMessage('block_navigation_bulk_edit.cancel')}
        confirmButtonLabel={formatMessage('block_navigation_bulk_edit.confirm')}
      />
    ),
    [formatMessage, showPrompt, confirmNavigation, cancelNavigation]
  )
}

export default BlockNavigationDialog
